import React, {useCallback, useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import NewHeader from "../components/NewHeader";
import MainStyle from "../../MainStyle";
import {FlatList, Image, NativeScrollEvent, NativeSyntheticEvent, Platform, ScrollView} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import moment from "moment";
import {BrandName, isFullSwing, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from "../constants";
import {
  Tournament, TournamentPlayerBet_State, TournamentPlayerDetails_State, TournamentPrizeDistributionItem, User
} from "../../generated/smg_service_pb";
import {StoreContext} from "../components/StoreContextProvider";
import useIdleLogout from "../hooks/useIdleLogout";
import {useIsFocused, useNavigation, useRoute} from "@react-navigation/native";
import ServiceClient from "../utils/ServiceClient";
import {CancelModalProps} from "../types";
import TournamentHeader from "../components/TournamentHeader";
import PrizePool from "../components/PrizePool";
import BottomNavigation from "../components/BottomNavigation";
import RegisteredPlayersStatus from "../components/RegisteredPlayersStatus";
import JoinTournamentButton from "../components/JoinTournamentButton";
import ContinueAutoPlayModal from "../modals/ContinueAutoPlay";
import {tournamentStatusStyle} from "../utils";
import Div from "../lib/Div";
import YourFriendChallengeCodeForm from "./User/friends/components/YourFriendChallengeCodeForm";

import P from "../lib/P";
import {colors} from "../assets/styles/colors";
import FSHeader from "../components/FSHeader";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import Btn from "../components/Btn";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import TournamentCard from "../components/TournamentCard";

const ITEM_WEIGHT = 387;

const TournamentDetails = () => {
  const Context = useContext(StoreContext);
  const {cancelModalConfig, user, session, extendedUserData} = Context;
  const isFocused = useIsFocused();
  const [tournament, setTournament] = useState<Tournament>();
  const route = useRoute();
  const params: any = route?.params;
  const id = typeof params?.id === 'string' ? Number(params.id) : params?.id;
  const isPrivateTournament = typeof params?.isPrivateTournament === 'string' ? params?.isPrivateTournament === 'true' : !!params?.isPrivateTournament;
  const showPopup = typeof params?.showPopup === 'string' ? params?.showPopup === 'true' : !!params?.showPopup;
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const [activeTab, setActiveTab] = useState(1);
  const flatListRef = useRef<FlatList<number>>(null);
  const [continueAutoPlay, setContinueAutoPlay] = useState(false);
  const registered = !!tournament?.currentPlayerDetails && tournament.currentPlayerDetails.state !== TournamentPlayerDetails_State.FINISHED;
  const statusStyle = tournamentStatusStyle(tournament?.state);
  const currentNumberOfShots = tournament?.currentPlayerDetails?.bets.filter(bet => bet.state === TournamentPlayerBet_State.FINISHED && bet.resolved).length || 0;
  const [showInviteCode, setShowInviteCode] = useState('');
  const [prizeDistribution, setPrizeDistribution] = useState<TournamentPrizeDistributionItem[]>();

  const getTournamentPrizeDistribution = (id: number) => {
    ServiceClient.getTournamentPrizeDistribution(id).then(res => {
      setPrizeDistribution(res?.items);

    }).catch(err => {
      console.log('getTournamentPrizeDistribution err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const leaveTournament = () => {
    if (!tournament) return;
    Context.setLoadingOverlay(true);

    ServiceClient.leaveTournament(tournament.id).then(() => {
      getTournament();

    }).catch(err => {
      console.log('leaveTournament err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'Error', subtitle: err.message, rightBtnText: 'OK',
        onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
      });
    });
  };

  const scrollToItem = (index: number) => {
    flatListRef.current?.scrollToIndex({animated: true, index: index});
  };

  const onScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const slideSize = event.nativeEvent.layoutMeasurement.width;
    setActiveTab(Math.ceil((event.nativeEvent.contentOffset.x + slideSize / 2) / 378));
  }, []);

  const getItemLayout = (data: any, index: number) => (
    {length: ITEM_WEIGHT, offset: ITEM_WEIGHT * index, index}
  );

  const renderItem = ({item}: any) => {
    if (!tournament) return <></>;
    else {
      return (
        <Div>
          <Div row>
            <Div flex={1} h={4} bg={item !== 1 ? 'transparent' : isFullSwing ? '#3369FF' : colors.filter_chip_bg}/>
            <Div flex={1} h={4} bg={item !== 2 ? 'transparent' : isFullSwing ? '#3369FF' : colors.filter_chip_bg}/>
          </Div>

          <Div h={1} mb={14} bg={colors.darkText}/>

          {item === 1 ? (
            <PrizePool
              w={ITEM_WEIGHT} maxH={248} b_b_r={0} state={tournament.state} prizePoolList={tournament.prizePool}
              playerDetailsList={tournament.playerDetails} guaranteedPricePool={tournament.minimumGuaranteedPricePool}
            />
          ) : (
            <RegisteredPlayersStatus
              w={ITEM_WEIGHT} maxH={248} b_b_r={0} item={tournament?.playerDetails}
              playerId={tournament.currentPlayerDetails?.playerId}
              guaranteedPricePool={tournament.minimumGuaranteedPricePool}
            />
          )}
        </Div>
      );
    }
  };

  const getTournament = () => {
    ServiceClient.getTournament(id).then(res => {
      Context.setLoadingOverlay(false);
      setTournament(res);
      if (extendedUserData.hasActiveTournament && extendedUserData.tournamentAutoPlayAmount === -3) setContinueAutoPlay(true);
      if (res?.seriesId) getTournamentPrizeDistribution(res.id);

    }).catch(err => {
      console.log('getTournament err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          navigation.navigate({name: 'account', params: {step: 1}});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const getUser = () => {
    Context.getUser().catch(err => {
      console.log('getUser err', err);
      setTimeout(() => {
        getUser();
      }, 5000);
    });
  };

  useEffect(() => {
    if (user?.kycStatus === 6) {
      Context.setCancelModalConfig({
        visible: true, title: 'ERROR', leftBtnText: 'Cancel', rightBtnText: 'Contact Support',
        subtitle: `Your Know Your Customer information and registration information do not match. Your account with ${BrandName} has been locked. Please contact support to resolve this issue.`,
        onResume: () => {
          if (Platform.OS === 'web') {
            window.open('https://smgames.atlassian.net/servicedesk/customer/portal/3', '_self');
          }
        },
        onClose: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          navigation.navigate({name: 'account', params: {step: 0}});
        }
      });
    }
  }, [user?.kycStatus]);

  useEffect(() => {
    if (!user || !isFocused) return;

    getTournament();

    const time = setTimeout(() => {
      getUser();
    }, 1000 * 10);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused]);

  useIdleLogout({enabled: isFocused, onLogout: () => Context.setLoadingOverlay(false)});

  useLayoutEffect(() => {
    Context.setLoadingOverlay(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            Context.setLoadingOverlay(false);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
              Context.setLoadingOverlay(false);
            });

          } else console.log('user', curUser);
        }
      })();
    }
  }, []);

  return (
    <>
      {isFullSwing ? (
        <>
          <FSHeader px={20}/>

          <Div h={2} bg="#252526"/>

          <Div gap={5} py={10} px={20}>
            <Div row alignItems="center">
              <Div w={24} alignItems="center"><FontAwesome name="user-circle" size={24} color="#3399FF"/></Div>
              <P fontFamily="DavisSans-Regular" ml={6}>{user?.username}</P>
            </Div>
          </Div>

          <Div h={2} bg="#252526"/>
        </>
      ) : <NewHeader/>}

      <ScrollView>
        {!isFullSwing && <P fw="500" fs={32} ml={21}>{isPrivateTournament ? 'Play With Friends' : 'Tournaments'}</P>}

        <Div row justifyContent="space-between" mb={isFullSwing ? 36 : 10} alignItems="center"
             py={isFullSwing ? 13 : 0}>
          <P fw="500" fs={22} ml={21}>
            {!isFullSwing && '/'} {isPrivateTournament ? 'Friend Challenge' : 'Tournament'} Details
          </P>

          {tournament?.seriesId ? (
            <P color={isFullSwing ? '#0AF' : colors.newGreenText} tt="uppercase" fs={isFullSwing ? 14 : 12}
               fontFamily={isFullSwing ? 'DavisSans-Medium' : 'Barlow-Bold'} mr={isFullSwing ? 18 : 5}
               ta={isFullSwing ? 'right' : undefined} w={isFullSwing ? 120 : undefined}
               onPress={() => navigation.reset({index: 0, routes: [{name: 'AllTournaments', params: {onlyCompleted: true}}]})}>
              See Completed Tournaments
            </P>
          ) : !isPrivateTournament ? (
            <Btn onPress={() => navigation.navigate(isPrivateTournament ? 'FriendsScreen' : 'tournaments')} mr={24}
                 justifyContent="center">
              <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="700" fs={14} tt="uppercase" ta="center">
                {isPrivateTournament ? 'Back' : '< Back to List'}
              </P>
            </Btn>
          ) : tournament?.tournamentCode ? (
            <Btn onPress={() => setShowInviteCode(tournament.tournamentCode)} mr={24} justifyContent="center">
              <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="700" fs={14} tt="uppercase" ta="center">
                Invite Code
              </P>
            </Btn>
          ) : null}
        </Div>

        {!isFullSwing && <Div h={1} bg={colors.divider_bg} mx={23} mb={18}/>}

        {tournament && (
          <>
            {isFullSwing ? (
              <TournamentCard
                tournament={tournament} getUser={getUser} getTournament={getTournament}
                goBack={() => console.log('goBack')} prizeDistribution={prizeDistribution}
              />
            ) : (
              <>
                <P ta="center" fw="500" fs={24} mb={7} numberOfLines={1}>{tournament.name}</P>
                <P color={colors.id_text} ta="center" fw="500" fs={20} lh={20} mb={5}>#{tournament.id}</P>

                {!!tournament.sponsorLandscapeLogo ? (
                  <Div h={72} w={120} mb={8} bg="white" rounded={6} mx="auto" overflow="hidden">
                    <Image
                      source={{uri: tournament.sponsorLandscapeLogo}} resizeMode="contain"
                      style={[MainStyle.absolute, MainStyle.h_271, MainStyle.t__99, MainStyle.w_271, MainStyle.l__75]}
                    />
                  </Div>
                ) : !!tournament.sponsorLogo ? (
                  <Div h={72} w={72} mb={8} bg="white" rounded={6} mx="auto" overflow="hidden">
                    <Image
                      source={{uri: tournament.sponsorLogo}} resizeMode="contain"
                      style={[MainStyle.absolute, MainStyle.h_234, MainStyle.t__81, MainStyle.w_184, MainStyle.l__56]}
                    />
                  </Div>
                ) : null}

                <Div mx="auto" w={367}>
                  <Div row mx={12} alignItems="center" mb={12}>
                    <Div column flex={1}>
                      <Div row mb={3} justifyContent="space-between">
                        <P fw="500" fs={14} lh={17} tt="uppercase">Start</P>
                        <P fw="600" lh={17}>{moment.unix(Number(tournament.entryBeginDate)).format('llll')}</P>
                      </Div>

                      <Div row justifyContent="space-between">
                        <P fw="500" fs={14} lh={17} tt="uppercase">End</P>
                        <P fw="600" lh={17}>{moment.unix(Number(tournament.entryEndDate)).format('llll')}</P>
                      </Div>
                    </Div>

                    <P w={82} lh={36} ta="center" bw={1} ml={13} fw="700" fs={14} tt="uppercase"
                       borderColor={statusStyle.color}>
                      {statusStyle.text}
                    </P>
                  </Div>
                </Div>

                {!registered && (
                  <TournamentHeader
                    mb={24} item={tournament} onReload={getUser} isPrivateTournament={isPrivateTournament}
                    showPopup={showPopup}
                  />
                )}

                <Div w={ITEM_WEIGHT} mx="auto">
                  <Div row mb={6}>
                    <P color={activeTab === 1 ? 'white' : colors.state_completed} flex={1} ta="center" fw="500"
                       onPress={() => scrollToItem(0)} lh={24}>
                      Prize Pool
                    </P>
                    <P color={activeTab === 2 ? 'white' : colors.state_completed} flex={1} ta="center" fw="500"
                       onPress={() => scrollToItem(1)} lh={24}>
                      {isFullSwing ? 'LEADERBOARD' : `Registered\nPlayers + Status`}
                    </P>
                  </Div>

                  <FlatList
                    ref={flatListRef} data={[1, 2]} initialScrollIndex={1} renderItem={renderItem} horizontal
                    keyExtractor={(item) => item.toString()} pagingEnabled onScroll={onScroll}
                    showsHorizontalScrollIndicator={false} style={MainStyle.m_b_12} getItemLayout={getItemLayout}
                  />

                  {registered && (
                    <TournamentHeader
                      mb={24} item={tournament} onReload={getUser} isPrivateTournament={isPrivateTournament}
                      showPopup={showPopup}
                    />
                  )}

                  <Div h={1} bg={colors.divider_bg} mb={10}/>
                </Div>
              </>
            )}

          </>
        )}
      </ScrollView>

      <Div flex={1}/>

      {(!isPrivateTournament || (isPrivateTournament && currentNumberOfShots === tournament?.totalShots)) && (
        <Btn mb={13} onPress={() => navigation.navigate(isPrivateTournament ? 'FriendsScreen' : 'tournaments')}>
          <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="700" fs={14} tt="uppercase" ta="center"
             lh={26}>
            {isPrivateTournament || isFullSwing ? '< Back' : '< Back to List'}
          </P>
        </Btn>
      )}

      {(!isFullSwing && !!tournament) && (
        <JoinTournamentButton
          tournament={tournament} onReload={getTournament} leave={leaveTournament}
          hideLeaveButton isTournamentSeries={!!tournament.seriesId}
        />
      )}

      <P color={colors.gray} ta="center" fs={17} mb={10}>Malfunction voids all pays and plays</P>

      <ContinueAutoPlayModal isOpen={continueAutoPlay} onClose={() => setContinueAutoPlay(false)} onReload={getUser}/>

      <YourFriendChallengeCodeForm code={showInviteCode} onClose={() => setShowInviteCode('')}/>

      {!isFullSwing && <BottomNavigation page={isPrivateTournament ? 'FriendsScreen' : 'tournaments'}/>}
    </>
  );
};

export default React.memo(TournamentDetails);
